import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WorkOrderService} from '../../../Services/work-order.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {WoDashboard} from '../../../DataModels/workorder-model';

@Component({
  selector: 'app-work-orders-dashboard',
  templateUrl: './work-orders-dashboard.component.html',
  standalone: false,
})
export class WorkOrdersDashboardComponent implements OnInit {

  dashboard: WoDashboard | null = null;
  isLoaded = false;
  fromDate = '';
  toDate = '';

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    private router: Router,
  ) {
    const now = new Date();
    const from = new Date(now);
    from.setDate(now.getDate() - 60);
    const to = new Date(now);
    to.setDate(now.getDate() + 30);
    this.fromDate = from.toISOString().substring(0, 10);
    this.toDate = to.toISOString().substring(0, 10);
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoaded = false;
    this.woService.getDashboard({from_date: this.fromDate, to_date: this.toDate}).subscribe({
      next: (res) => {
        this.dashboard = res;
        this.isLoaded = true;
      },
      error: () => {
        this.notification.showErrorToast('Error loading dashboard.');
        this.isLoaded = true;
      }
    });
  }

  goToList(filter?: string): void {
    const extras: any = {};
    if (filter) {
      extras.queryParams = {status: filter};
    }
    this.router.navigate(['/work-orders/work-orders-list'], extras);
  }

  goToWo(id: string): void {
    this.router.navigate(['/work-orders/work-orders-form'], {queryParams: {id}});
  }

  goToPmSchedule(scheduleId: string): void {
    this.router.navigate(['/work-orders/pm-schedules/pm-schedule-form'], {queryParams: {id: scheduleId}});
  }
}
